import styled from 'styled-components';

import { NewStyleColor } from '../../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../../utils/style';

const Wrapper = styled('div')`
	position: absolute;
	top: 4px;
	right: 10px;
`;

const Icon = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	cursor: pointer;

	svg {
		width: 20px;
		height: 20px;
		fill: ${hexToRgba(NewStyleColor.White, 90)};
	}
`;

const Content = styled('div')`
	position: absolute;
	top: 100%;
	right: 0;
	z-index: 1;
	width: 295px;
	padding: 16px;
	border-radius: 8px;
	background-color: ${NewStyleColor.Grey800};
	box-shadow: 0 3px 35px 0 ${hexToRgba(NewStyleColor.Black, 50)};
	font-family: HelveticaNeue, sans-serif;
	font-size: 17px;
	line-height: 22px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
`;

export {
	Wrapper,
	Icon,
	Content,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SpreadBackgroundPanel/MediaPreview/Tooltip/styles.ts